<template>
  <div id="wrapper">

    <div class="normalheader transition">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Projects'}">Projects</router-link></li>
              <li><router-link :to="{name: 'ProjectDetails', params: {id: projectId}}">Project Overview</router-link></li>
              <li class="active"><router-link :to="{name: 'ChatSolution', params: {project_id: projectId, question_id: questionId}}">Interact</router-link></li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs" v-if="project">
            Interact with experts - <router-link class="font-bold text-info" :to="{name: 'ProjectDetails', params: {id: projectId}}">{{project.name}}</router-link>
          </h3>
          <small>Keep track of interactions with experts</small>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="hpanel ">
        <ul class="nav nav-tabs">
          <li class="active"><a data-toggle="tab" href="#tab-1">Message room <span style="font-style: italic;font-weight: normal">(experts with enabled account)</span></a></li>
          <li class=""><a data-toggle="tab" href="#tab-2">Interaction notes (all contacted experts)</a></li>
        </ul>
        <div class="tab-content">
          <div id="tab-1" class="tab-pane active">
            <div class="panel-body no-padding">
              <chat :questionId="questionId"/>

            </div>

          </div>
          <div id="tab-2" class="tab-pane">
            <div class="panel-body no-padding">
              <commentary :questionId="questionId"/>
            </div>

          </div>

        </div>
      </div>
      <div class="hpanel ">
        <div class="panel-heading">
          Responses from experts
        </div>

        <solution :questionId="questionId"/>
      </div>

    </div>
  </div>
</template>

<style>
</style>

<script>
import Chat from '../../components/chatSolution/Chat'
import Solution from '../../components/chatSolution/Solution'
import Commentary from '../../components/chatSolution/Commentary'

export default {
  components: {
    Commentary,
    Solution,
    Chat},
  props: [],
  name: 'ChatSolution',
  data () {
    return {
      projectId: null,
      questionId: null,
      project: null
    }
  },
  methods: {
    getResources: function () {
      if (this.projectId !== null) {
        this.axios.get('/project/' + this.projectId)
          .then((response) => {
            this.project = response.data
          })
          .catch((error) => {
          })
      }
    }
  },
  beforeMount () {
    this.projectId = parseInt(this.$route.params.project_id)
    this.questionId = parseInt(this.$route.params.question_id)
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/chatSolution/ChatSolution.vue